import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createSuper";
import { RotateAnimation } from "./RotateAnimation";
import { ValueWithRandom } from "../../ValueWithRandom";
export var Rotate = /*#__PURE__*/function (_ValueWithRandom) {
  _inherits(Rotate, _ValueWithRandom);
  var _super = _createSuper(Rotate);
  function Rotate() {
    var _this;
    _classCallCheck(this, Rotate);
    _this = _super.call(this);
    _this.animation = new RotateAnimation();
    _this.direction = "clockwise";
    _this.path = false;
    _this.value = 0;
    return _this;
  }
  _createClass(Rotate, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }
      _get(_getPrototypeOf(Rotate.prototype), "load", this).call(this, data);
      if (data.direction !== undefined) {
        this.direction = data.direction;
      }
      this.animation.load(data.animation);
      if (data.path !== undefined) {
        this.path = data.path;
      }
    }
  }]);
  return Rotate;
}(ValueWithRandom);